import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import PageBase from '../components/PageBase';
import AccountForm from '../components/AccountForm';
import * as accountActions from '../redux/modules/accounts';
import i18n from '../translations/i18n';

/*
PropTypes / DefaultProps
 */
const propTypes = {
  createAccount: PropTypes.func,
  t: PropTypes.func,
};

const defaultProps = {};

class AccountCreate extends React.Component {
  createAccount = (values) => {
    this.props.createAccount(values);
  };

  render() {
    return (
      <PageBase title={this.props.t('create_new_account')}>
        <AccountForm onSubmit={this.createAccount} isModify={false} data="" />
      </PageBase>
    );
  }
}

AccountCreate.defaultProps = defaultProps;
AccountCreate.propTypes = propTypes;

const extended = translate(['translations'], { i18n })(AccountCreate);
export default connect(null, accountActions)(extended);



// WEBPACK FOOTER //
// ./src/containers/AccountCreate.js